import React, { Component } from "react";
import Hero from './../../alpineComponents/hero';
import CenteredParagraph from './../../alpineComponents/centeredParagraph';
import HorizontalScroller from './../../alpineComponents/horizontalScroller';
import PaymentInfo from './../../components/paymentInfo';
import { Link } from "react-router-dom";
import  './../../utils/analytics';


export default class extends Component {
  render() {
    return (
		<div className="light-grey-background">
      <Hero
				title={'Online sessions via Zoom, Skype or FaceTime'}
				backgroundImage={'images/online-hero.jpg'}
				height={'threequarter'} /*full, half,threequarter*/
        subtitlePosition={'top'}
        tint={'medium'}
      />
      <div className="section-padding">
        <div className="max-width-container">
          <div className="row">
            <div className="small-12 medium-12 tiny-padding">
              <div className="small-padding primary-background shadow full-height relative anchor-padding centered-text">
                <h2 className="white">{'$99'}</h2>
                <h5 className="white">{'Introductory private session'}</h5>
                <p className="white">{'First one-on-one session for new clients only'}</p>
                <Link to="/contact">
                  <h6 className="button" style={{backgroundColor:'#fff',color:"#ee6725", marginTop:'40px'}}>{'Contact Us'}</h6>
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="small-12 medium-6 tiny-padding">
              <div className="small-padding white-background shadow full-height relative">
                <h4>{'Private Sessions - 50 min'}</h4>
                <ul>
                  <li><b className="primary-color">{'$130'}</b><span  className="subheading">{' when purchased in pack of 10 ($1300)'}</span></li>
                  <li><b className="primary-color">{'$135'}</b><span  className="subheading">{' when purchased in pack of five ($675)'}</span></li>
                  <li><b className="primary-color">{'$145'}</b><span  className="subheading">{' single class'}</span></li>
                </ul>
                <Link to="/contact">
                  <h6 className="button" style={{backgroundColor:'#ee6725',color:"#fff", marginTop:'30px'}}>{'Contact Us'}</h6>
                </Link>
                <p className="subheading" style={{marginTop:'30px'}}><i>{'Private sesssions are one on one, 50 minutes.'}</i></p>
              </div>
            </div>
            <div className="small-12 medium-6 tiny-padding">
              <div className="small-padding white-background shadow full-height relative">
                <h4>{'Express Private Sessions - 25 min'}</h4>
                <ul>
                  <li><b className="primary-color">{'$75'}</b><span  className="subheading">{' per class'}</span></li>
                </ul>
                <Link to="/contact">
                  <h6 className="button" style={{backgroundColor:'#ee6725',color:"#fff", marginTop:'30px'}}>{'Contact Us'}</h6>
                </Link>
              </div>
            </div>
            <div className="small-12 medium-6 tiny-padding">
              <div className="small-padding white-background shadow full-height relative">
                <h4>{'Duet Sessions - 50 min'}</h4>
                <ul>
                  <li><b className="primary-color">{'$85'}</b><span  className="subheading">{' per person per class'}</span></li>
                </ul>
                <Link to="/contact">
                  <h6 className="button" style={{backgroundColor:'#ee6725',color:"#fff", marginTop:'30px'}}>{'Contact Us'}</h6>
                </Link>
                <p className="subheading" style={{marginTop:'30px'}}><i>{'Duet sessions are two students to one teacher, 50 minutes.'}</i></p>
              </div>
            </div>
            <div className="small-12 medium-6 tiny-padding">
              <div className="small-padding white-background shadow full-height relative">
                <h4>{'Quickie mat/stretch - 30 min'}</h4>
                <ul>
                  <li><b className="primary-color">{'$28'}</b><span  className="subheading">{' once a week per class '}</span></li>
                  <li><b className="primary-color">{'$25'}</b><span  className="subheading">{' per class for the whole month'}</span></li>
                </ul>
                <Link to="/contact">
                  <h6 className="button" style={{backgroundColor:'#ee6725',color:"#fff", marginTop:'30px'}}>{'Contact Us'}</h6>
                </Link>
                <p className="subheading" style={{marginTop:'30px'}}><i>{'Please inquire for day/time'}</i></p>
              </div>
            </div>

            ”
          </div>
        </div>
      </div>
      <img className="full-width" src="/images/seniors.jpg" />
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/online/index.js